/**
 * SearchBarV2 Styled Components
 */
import styled from 'styled-components'
import Input from 'antd/lib/input'

interface ContainerProps {
  searchWidth?: string
}

export const Container = styled.div`
  width: ${({ searchWidth }: ContainerProps) => searchWidth || '100%'};
  max-width: 476px;
`

export const SearchInput = styled(Input)`
  && {
    height: 58px;
    padding: 1px var(--spacing-16);
    background: var(--neutral-white);
    border: var(--border-heavy) solid var(--neutral-darkest);
    border-radius: var(--radius-none);
    box-shadow: none;
    display: flex;
    align-items: center;
  }

  &&:hover,
  &&:focus,
  &&.ant-input-affix-wrapper:hover,
  &&.ant-input-affix-wrapper-focused {
    border-color: var(--neutral-darkest);
    box-shadow: none;
  }

  .ant-input {
    height: 100%;
    border: 0;
    box-shadow: none;
    background: transparent;
    color: var(--neutral-darkest);
    font: 400 14px/22px var(--font-inter);
    padding: 0;

    &::placeholder {
      color: var(--neutral-secondary);
    }

    &:focus {
      box-shadow: none;
    }
  }

  .ant-input-suffix {
    display: flex;
    align-items: center;
    margin-left: var(--spacing-8);
  }

  .ant-input-clear-icon {
    color: var(--neutral-secondary);
    font-size: 16px;
    margin-right: var(--spacing-8);

    &:hover {
      color: var(--neutral-darkest);
    }
  }
`

export const SearchIconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  padding: 0;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: var(--neutral-secondary);

  &:hover {
    color: var(--neutral-darkest);
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SearchBar/styledComponents.tsx